import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";

const data = [
  { name: "Jan", old: 400, new: 240, amt: 2400 },
  { name: "Feb", old: 300, new: 139, amt: 2210 },
  { name: "Mar", old: 200, new: 980, amt: 2290 },
  { name: "Apr", old: 278, new: 390, amt: 2000 },
  { name: "May", old: 189, new: 480, amt: 2181 },
  { name: "Jun", old: 239, new: 380, amt: 2500 },
  { name: "Jul", old: 349, new: 430, amt: 2100 },
  { name: "Aug", old: 300, new: 410, amt: 2300 },
  { name: "Sep", old: 280, new: 360, amt: 2200 },
  { name: "Oct", old: 260, new: 390, amt: 2250 },
  { name: "Nov", old: 310, new: 420, amt: 2400 },
  { name: "Dec", old: 330, new: 450, amt: 2500 }
];

export default function Chart() {
  return (
    <div style={{ width: "100%", height: 300 }}>
      <ResponsiveContainer>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" stroke="#fff" />
          <YAxis stroke="#fff" />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="old" stroke="#00E5FF" strokeWidth={3} />
          <Line type="monotone" dataKey="new" stroke="#FF4081" strokeWidth={3} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
